// extracted by mini-css-extract-plugin
export var layoutContainer = "_42-0";
export var layoutContainerOpen = "_42-5";
export var layoutContainerResizing = "_42-1";
export var mainContent = "_42-2";
export var resizeDivider = "_42-3";
export var slidePanel = "_42-4";